"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionType = exports.Status = exports.EventType = void 0;
exports.EventType = {
    NOTE: 'Note',
    NOTE_ADDED: 'Note Added',
    PUBLISHED_TO_COMPANY_DASHBOARD: 'Published to company dashboard',
    MATCH_CREATED: 'Match Created',
    PROPOSAL_ACCEPTED: 'Proposal accepted',
    PROPOSAL_REJECTED: 'Proposal rejected',
    LISTED_FOR_SHORTLIST: 'Listed for shortlist',
    READY_TO_PUBLISH_IN_SHORTLIST: 'Ready to publish in shortlist',
    PUBLISHED_IN_SHORTLIST: 'Published in shortlist',
    MOVED_TO_INTERVIEW: 'Moved to interview',
    MOVED_TO_OFFER: 'Moved to offer',
    OFFER_ACCEPTED: 'Offer Accepted',
    OFFER_REJECTED: 'Offer Rejected',
    REJECTED_BY_DEV: 'Rejected by dev',
    REJECTED_BY_COMPANY: 'Rejected by company',
    POSITION_UNPUBLISHED: 'Position unpublished',
    DELISTED: 'Delisted',
    LISTED: 'Listed',
    READY_TO_PUBLISH: 'Ready to publish',
    RESTORED_TO_SHORTLIST: 'Restored to shortlist'
};
exports.Status = {
    INITIAL: 'New',
    INVALID: 'Invalid',
    MATCH: 'Match',
    OPPORTUNITY: 'Opportunity',
    INTERVIEW: 'Interview',
    OFFER: 'Offer',
    HIRED: 'Hired',
    SELECTION: 'Selection',
    FAILED_MATCH: 'Failed match',
    FAILED_SELECTION: 'Failed selection',
    ARCHIEVED: 'Archived',
    EXPIRED_MATCH: 'Expired match'
};
exports.ActionType = {
    INITIAL: 'INITIAL',
    EDIT_MATCH_CONFIRMATION: 'Edit match confirmation',
    BACK: 'BACK',
    ROUTING: 'ROUTING',
    OPEN_NOTES: 'OPEN_NOTES',
    CLOSE_NOTES: 'CLOSE_NOTES',
    FAILED_POSITION_UNPUBLISHED: 'Failed for position unpublished',
    PUBLISH_CLIENT_DASHBOARD: 'Publish on Client Dashboard',
    ARCHIVE: 'Archive',
    MOVE_SELECTION_TO_OFFER: 'Move selection to offer',
    MOVE_SELECTION_TO_INTERVIEW: 'Move selection to interview',
    RESTORE_TO_SHORTLIST: 'Restore to shortlist',
    PROPOSAL_ACCEPTED: 'Proposal accepted',
    PROPOSAL_REJECTED: 'Proposal rejected',
    OFFER_ACCEPTED: 'Offer accepted',
    OFFER_REJECTED: 'Offer rejected',
    REJECTED_BY_DEV: 'Rejected by candidate',
    REJECTED_BY_COMPANY: 'Rejected by company',
    MATCH_CREATED: 'Match created',
    /**
     * @deprecated
     */
    LISTED_FOR_SHORTLIST: 'Listed for shortlist',
    /**
     * @deprecated
     */
    READY_TO_PUBLISH_IN_SHORTLIST: 'Ready to publish in shortlist',
    PUBLISHED_IN_SHORTLIST: 'Published in shortlist',
    LISTED: 'Listed',
    DELISTED: 'Delisted',
    READY_TO_PUBLISH: 'Ready to publish'
};
//# sourceMappingURL=const.js.map